<template>
    <nav class="nxl-navigation">
        <div class="navbar-wrapper">
            <div class="m-header">
                <a href="index.html" class="b-brand">
                    <!-- ========   change your logo hear   ============ -->
                    <img src="/logo-full.svg" alt="" class="logo logo-lg img-fluid">
                </a>
                <a href="index.html" class="b-brand">
                    <img src="/logo-abbr.svg" alt="" class="logo logo-sm">
                </a>
            </div>
            <div class="navbar-content">
                <ul class="nxl-navbar">
                    <li class="nxl-item nxl-caption">
                        <label>Gezinti Bölmesi</label>
                    </li>
                    <li class="nxl-item nxl-hasmenu">
                        <router-link to="/dashboard" class="nxl-link">
                            <span class="nxl-micon"><i class="feather-airplay"></i></span>
                            <span class="nxl-mtext">Gösterge Paneli</span><span class="nxl-arrow"></span>
                        </router-link>
                    </li>
                    <li class="nxl-item nxl-hasmenu">
                        <a href="javascript:void(0);" class="nxl-link">
                            <span class="nxl-micon"><i class="feather-cast"></i></span>
                            <span class="nxl-mtext">Listeler</span><span class="nxl-arrow"><i
                                    class="feather-chevron-right"></i></span>
                        </a>
                        <ul class="nxl-submenu">
                            <li class="nxl-item">
                                <router-link to="/animal/list/1" class="nxl-link">Hayvan Listesi</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/shelter/list/1" class="nxl-link">Barınak Listesi</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/medicine/list/1" class="nxl-link">İlaç Listesi</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/warehouse/list/1" class="nxl-link">İlaç Deposu Listesi</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/medicine_transaction/list/1" class="nxl-link">İlaç Hareketleri
                                    Listesi</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/supplier/list/1" class="nxl-link">Tedarikçi
                                    Listesi</router-link>
                            </li>
                            <li class="nxl-item" v-if="user.is_superuser">
                                <router-link to="/user/list/1" class="nxl-link">Kullanıcı
                                    Listesi</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nxl-item nxl-hasmenu">
                        <a href="javascript:void(0);" class="nxl-link">
                            <span class="nxl-micon"><i class="feather-cast"></i></span>
                            <span class="nxl-mtext">Diğer İşlemler</span><span class="nxl-arrow"><i
                                    class="feather-chevron-right"></i></span>
                        </a>
                        <ul class="nxl-submenu">
                            <li class="nxl-item">
                                <router-link to="/animal/species" class="nxl-link">Hayvan Türleri</router-link>
                            </li>
                            <li class="nxl-item">
                                <router-link to="/medicine/input" class="nxl-link">İlaç Girişi</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'Sidebar',
    data() {
        return {
            user: {}
        }
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('user'));
        console.log(this.user.is_superuser);

        document.addEventListener("DOMContentLoaded", function () {
            992 < window.innerWidth && document.querySelectorAll(".nxl-header .header-wrapper .dropdown").forEach(function (e) {
                e.addEventListener("mouseover", function (e) {
                    var n, t = this.querySelector("a[data-bs-toggle]");
                    null != t && (n = t.nextElementSibling, t.classList.add("show"), n.classList.add("show"))
                }), e.addEventListener("mouseleave", function (e) {
                    var n, t = this.querySelector("a[data-bs-toggle]");
                    null != t && (n = t.nextElementSibling, t.classList.remove("show"), n.classList.remove("show"))
                })
            })
        });
    },
}
</script>